<!-- <h3 i18n='Banking data edit modal title@@customerOverviewComponent.modalTitle.editBankingData'>Edit banking data</h3> -->

<app-workspace-form [formGroup]="updateBankDataForm"
                    [form]="updateBankDataForm"
                    [formName]="'updateBankDataForm'"
                    [pageTitle]="pageTitle"
                    [isFormValid]="isIbanValid && customer.isEditable"
                    [spinnerName]="spinnerName"
                    [submitButtonText]="buttonsTranslations.i18nSubmit"
                    [cancelButtonText]="buttonsTranslations.i18nBack"
                    (cancelButtonEvent)="customerOverviewService.toggleAllModal($event)"
                    (submitButtonEvent)="updateBankDataFormSubmit($event)">

  <div app-form-field-iban-checker
       [control]="updateBankDataForm.controls['IBAN']"
       [isEdit]="true"
       (searchResults)="fillFormData($event)">
  </div>
  <div app-form-field-text-generic
       [control]="updateBankDataForm.get('BIC')"
       [label]="flTranslations.i18nBIC">
  </div>
  <div app-form-field-text-generic
       [control]="updateBankDataForm.get('bankName')"
       [label]="flTranslations.i18nBankName">
  </div>

  <div class="esf-form-item" style="margin-bottom: 50px;">
    <label i18n='Form label text@@general.formLabel.differentBankAccountHolder' class="esf-form-item__label">Different bank account holder</label>
    <div class="esf-toggle">
      <input class="esf-toggle__input" type="checkbox" id="differentHolder"
             [ngModel]="hasAddress" (ngModelChange)="changeAccountHolder($event)" [ngModelOptions]="{standalone: true}">
      <label class="esf-toggle__label" for="differentHolder">
        <div class="esf-toggle__button">
          <div class="esf-toggle__button-background">
            <div class="esf-toggle__button-handle"></div>
          </div>
        </div>
      </label>
    </div>
  </div>

  <div formGroupName="address" *ngIf="hasAddress">
    <div class="esf-form-group">
      <div app-form-field-text-generic
           class="esf-form-item--1-2"
           [control]="updateBankDataForm.get('address').get('firstName')"
           [label]="flTranslations.i18nFirstName">
      </div>
      <div app-form-field-text-generic
           class="esf-form-item--1-2"
           [control]="updateBankDataForm.get('address').get('lastName')"
           [label]="flTranslations.i18nLastName">
      </div>
    </div>
    <div class="esf-form-item esf-form-validation">
      <label i18n='Form label textForm label text@@general.formLabel.street' class="esf-form-item__label" for="street">Street</label>
      <input class="esf-form-item__field awesomplete" id="street"
             i18n-placeholder="Form placeholder text@@general.formPlaceholder.street"
             placeholder="Enter street"
             formControlName="street"
             [appGooglePlaces]="updateBankDataForm.get('address').get('street')"
             (onAddressSelect)="fillAddressValues($event)">
    </div>
    <div class="esf-form-group">
      <div class="esf-form-item esf-form-item--1-2 esf-form-validation">
        <label i18n='Form label textForm label text@@general.formLabel.postalCode'
               class="esf-form-item__label" for="postalCode">Post code</label>
        <input class="esf-form-item__field awesomplete" id="postCode"
               i18n-placeholder="Form placeholder text@@general.formPlaceholder.postalCode"
               placeholder="Enter Post code"
               formControlName="postalCode">
      </div>
      <div class="esf-form-item esf-form-item--1-2 esf-form-validation">
        <label i18n='Form label textForm label text@@general.formLabel.city' class="esf-form-item__label" for="city">City</label>
        <input type="text" class="esf-form-item__field awesomplete" id="city"
               i18n-placeholder="Form placeholder text@@general.formPlaceholder.city"
               placeholder="Enter city"
               formControlName="city">
      </div>
    </div>
    <div app-form-field-select
         [control]="updateBankDataForm.get('address').get('country')"
         [label]="flTranslations.i18nCountry"
         [array]="countries"
         [valueKey]="'iso2'"
         [textKey]="'name'">
    </div>
  </div>
</app-workspace-form>
